import {TableRow} from '@material-ui/core';
import styled from 'styled-components';

const TRow = styled(TableRow)``;
export default TRow;
